/**
 * Typ akce frame.
 *
 * @ignore
 */
enum FrameActionType {
    /**
     * Nastavení pozastavení odebírání z fronty zpráv.
     */
    SET_POST_SUSPENDED = 'frame.setPostSuspended',

    /**
     * Odebrání zprávy z fronty.
     */
    POST_MESSAGE = 'frame.postMessage',

    /**
     * Smazání fronty zpráv.
     */
    CLEAR_MESSAGES = 'frame.clearMessages',
}

export default FrameActionType;
